// =========================================================================
// Sanitizador y Filtro de Palabras Inapropiadas (Español / Inglés)
// Previene el guardado de groserías, lenguaje obsceno o no profesional
// =========================================================================

export const FORBIDDEN_WORDS = [
    // --- Español (Groserías, insultos, lenguaje vulgar) ---
    'puto', 'puta', 'putos', 'putas', 'putita', 'putito', 'putamadre', 'hijodeputa', 'hdp',
    'mierda', 'mierdas', 'mierdoso', 'mierdosa',
    'pendejo', 'pendeja', 'pendejos', 'pendejas', 'pendejada', 'pendejadas',
    'verga', 'vergas', 'vergazo', 'vergazos', 'alv',
    'chingar', 'chinga', 'chingas', 'chingada', 'chingado', 'chingados', 'chingadas', 'chingon', 'chingona', 'chingue', 'chingues', 'chingadera', 'chingaderas',
    'cabron', 'cabrona', 'cabrones', 'cabronas', 'cabronada',
    'culero', 'culera', 'culeros', 'culeras', 'culo', 'culos', 'culito',
    'pinche', 'pinches',
    'mamon', 'mamona', 'mamones', 'mamada', 'mamadas',
    'madrazo', 'madrazos', 'desmadre',
    'idiota', 'idiotas', 'estupido', 'estupida', 'estupidos', 'estupidas', 'imbecil', 'imbeciles',
    'zorra', 'zorras', 'perra', 'perras',
    'maricon', 'maricones', 'marica', 'maricas',
    'coño', 'joder', 'jodido', 'jodida', 'jodidos', 'jodidas', 'carajo',
    'pito', 'pitos', 'tetas', 'panocha', 'vergon', 'cagada', 'cagar', 'cago', 'cagas',
    'bastardo', 'bastarda', 'malparido', 'malparida', 'carechimba', 'gonorrea',

    // --- English (Profanity, swear words, offensive language) ---
    'fuck', 'fucking', 'fucker', 'fuckers', 'fucked', 'fucks', 'motherfucker', 'motherfucking',
    'shit', 'shitty', 'shits', 'bullshit',
    'bitch', 'bitches', 'bitching',
    'asshole', 'assholes', 'dumbass', 'jackass', 'badass',
    'bastard', 'bastards',
    'cunt', 'cunts',
    'dick', 'dicks', 'dickhead',
    'pussy', 'pussies',
    'whore', 'whores', 'slut', 'sluts',
    'cock', 'cocks', 'cocksucker',
    'nigger', 'nigga', 'niggers', 'niggas',
    'fag', 'faggot', 'faggots',
    'retard', 'retarded',
    'blowjob', 'handjob',
    'boobs', 'penis', 'vagina'
];

/**
 * Normaliza el texto removiendo diacríticos/acentos y caracteres leet comunes.
 */
export const normalizeProfanityText = (text) => {
    if (!text || typeof text !== 'string') return '';
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Elimina acentos (á->a, ó->o, etc.)
        .toLowerCase()
        .replace(/[@]/g, 'a')
        .replace(/[$]/g, 's')
        .replace(/[0]/g, 'o')
        .replace(/[1!|]/g, 'i')
        .replace(/[3]/g, 'e');
};

/**
 * Valida si un texto contiene palabras prohibidas u ofensivas.
 * @param {string} text Texto a evaluar
 * @returns {{ isValid: boolean, foundWord: string|null, errorMessage: string|null }}
 */
export const validateInappropriateLanguage = (text) => {
    if (!text || typeof text !== 'string' || !text.trim()) {
        return { isValid: true, foundWord: null, errorMessage: null };
    }

    const normalized = normalizeProfanityText(text);

    for (const forbidden of FORBIDDEN_WORDS) {
        // Delimitador estricto para no generar falsos positivos con palabras legítimas
        // Ej: no debe coincidir "puta" dentro de "disputa" o "computadora"
        const regex = new RegExp(`(^|[^a-z0-9])${forbidden}([^a-z0-9]|$)`, 'i');
        if (regex.test(normalized)) {
            return {
                isValid: false,
                foundWord: forbidden,
                errorMessage: `El texto contiene un término o palabra no permitida ("${forbidden}"). Por favor, utiliza un lenguaje apropiado y profesional.`
            };
        }
    }

    return { isValid: true, foundWord: null, errorMessage: null };
};

/**
 * Retorna true si el texto contiene lenguaje inapropiado.
 */
export const containsInappropriateLanguage = (text) => {
    return !validateInappropriateLanguage(text).isValid;
};
